import { Grid, GridProps } from "@chakra-ui/react"

function DescriptionList({ children, ...rest }: { children: React.ReactNode } & GridProps) {
  return (
    <Grid width={"100%"} as="dl" {...rest}>
      {children}
    </Grid>
  )
}

export default DescriptionList
